import { NgModule } from '@angular/core'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
import { orderTranslationChunksConfig, orderTranslations } from '@spartacus/order/assets'
import { OrderDetailsService } from '@spartacus/order/components'
import { ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root'
import { EbOrderModule } from './eb-order.module'
import { EbOrderDetailsService } from './services/facades/eb-order-details.service'

@NgModule({
  imports: [OrderRootModule, EbOrderModule],
  declarations: [],
  providers: [
    provideConfig({
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('./eb-order.module').then(m => m.EbOrderModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: orderTranslations,
        chunks: orderTranslationChunksConfig
      }
    } as I18nConfig),
    {
      provide: OrderDetailsService,
      useClass: EbOrderDetailsService
    }
  ]
})
export class EbOrderFeatureModule {}
